import {Dayjs} from "dayjs";
import {Order} from "../virtualTable/Order/Order";

export class OrdersAggregatedByDate {
    constructor(
        public readonly date: Dayjs,
        public readonly orders: Order[]
    ) {
    }
}